import React, { useContext, useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import AuthContext from '../../context/auth/AuthContext'
import { DropdownContent } from './DropdownContent'
import carrot from '../../img/icon-carrot-small.png'
import HamburgerMenu from '../ui/HamburgerMenu'
import {
  ClipboardCheckIcon,
  GridIcon,
  HomeIcon,
  OfficeBuildingIcon,
} from '../../img/images'
import NavBarSelect from './NavBarSelect'
import { withComponentLabel } from '../../utils/debug'

const AppNavBar = () => {
  const [overlayVisibility, setOverlayVisibility] = useState('invisible')
  const [sliderDisplay, setSliderDisplay] = useState('w-0')

  const authContext = useContext(AuthContext)

  const { isAuthenticated, logout, loading } = authContext

  const homePage = isAuthenticated ? '/home' : '/'

  const onClickHamburger = () => {
    overlayVisibility === 'invisible'
      ? setOverlayVisibility('visible')
      : setOverlayVisibility('invisible')
    sliderDisplay === 'w-0' ? setSliderDisplay('w-60') : setSliderDisplay('w-0')
  }

  const navOptions = [
    {
      label: 'Items',
      target: '/items',
      icon: <HomeIcon color="fill-orange-500" />,
    },
    {
      label: 'Lists',
      target: '/lists',
      icon: (
        <ClipboardCheckIcon
          fill="fill-orange-500"
          stroke="white"
        />
      ),
    },
    {
      label: 'Homes',
      target: '/homes',
      icon: <GridIcon fill="fill-orange-500" />,
    },
    {
      label: 'Stores',
      target: '/stores',
      icon: (
        <OfficeBuildingIcon
          fill="fill-orange-500"
          stroke=""
        />
      ),
    },
  ]

  return (
    <>
      <nav className="bg-orange-600 merriweather flex justify-center text-white py-2 relative">
        <div className="flex max-w-screen-xl flex-grow justify-between px-3 sm:w-10">
          <div className="flex items-center">
            <Link
              to={homePage}
              className="flex align-center h-9"
            >
              <img
                className="mx-2"
                alt="Grocerylist.me logo"
                src={carrot}
              ></img>
              <div className="mt-0.5 font-bold text-2xl relative">
                <div className='after:content-["Beta"] after:bg-emerald-500 after:rounded-full after:absolute after:-bottom-4 after:-left-8 after:px-2 after:text-sm'>
                  Grocerylist.me
                </div>
              </div>
            </Link>
            {/* <HelpNav /> */}
          </div>
          <div
            className="h-12 w-12 md:hidden"
            onClick={() => onClickHamburger()}
          >
            <div className="flex items-center justify-center h-full w-full">
              <div className="flex flex-col relative justify-between h-1/2 w-full">
                <input
                  type="checkbox"
                  className="absolute top-0 left-0 peer h-full w-full z-20 cursor-pointer opacity-0"
                  checked={sliderDisplay === 'w-0' ? false : true}
                />
                <div className="z-0 bg-white w-4/5 rounded-full h-1 transition-all peer-checked:-translate-y-1"></div>
                <div className="z-0 rounded-full w-4/5 h-1 bg-white transition-all peer-checked:w-1/2 peer-checked:translate-x-2"></div>
                <div className="z-0 bg-white w-4/5 rounded-full h-1 transition-all peer-checked:translate-y-1"></div>
              </div>
            </div>
            <HamburgerMenu
              overlayVisibility={overlayVisibility}
              sliderDisplay={sliderDisplay}
            >
              <DropdownContent
                authenticated={isAuthenticated}
                mobile={true}
                options={navOptions}
              />
            </HamburgerMenu>
          </div>
          <div className="hidden md:flex">
            {isAuthenticated ? (
              <>
                {[
                  ...navOptions.map((option, index) => (
                    <NavBarSelect
                      key={index}
                      {...option}
                    />
                  )),
                  <Link
                    onClick={logout}
                    to=""
                    className=" flex items-center px-2 mx-2 tracking-wider font-bold"
                    key="logout"
                  >
                    Sign Out
                  </Link>,
                ]}
              </>
            ) : (
              <>
                <Link
                  className="flex px-10 mx-2 items-center tracking-wider font-bold"
                  to="/login"
                  key="login"
                >
                  <span className="">Sign In</span>
                </Link>
                <Link
                  className="flex font-bold tracking-widest items-center px-7 mx-2 bg-orange-400 text-slate-200 rounded-2xl hover:bg-orange-300 hover:text-gray-500 ease-in-out duration-300"
                  to="/register"
                  key="register"
                >
                  Sign Up!
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>
    </>
  )
}

export default withComponentLabel(AppNavBar, 'AppNavBar')